import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function NHLEGradeFilter({ setFilter, removeFilter, facets, filters }) {
  const viableGrades = ['I', 'II*', 'II'];

  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="grade"
      filters={filters}
      formHint="For listed building / park and garden only"
      id="grade"
      label="Grade"
      limitedOptions={viableGrades}
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(NHLEGradeFilter);
